import { render } from "./adminCreation.vue?vue&type=template&id=767095e8&scoped=true"
import script from "./adminCreation.vue?vue&type=script&lang=js"
export * from "./adminCreation.vue?vue&type=script&lang=js"

import "./adminCreation.vue?vue&type=style&index=0&id=767095e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767095e8"]])

export default __exports__